import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2608393e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-5 pb-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center",
  style: {"height":"120px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "px-4 py-3"
}
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center items-center",
  style: {"height":"120px"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "px-4 py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_ReviewEntryHeader = _resolveComponent("ReviewEntryHeader")!
  const _component_ReviewEntryElement = _resolveComponent("ReviewEntryElement")!
  const _component_ButtonPanel = _resolveComponent("ButtonPanel")!
  const _component_BasePanel = _resolveComponent("BasePanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonPanel, {
      buttonIcon: 'refresh',
      click: _ctx.refresh,
      icon: "speaker_notes",
      title: _ctx.$t(`message.openEntries`)
    }, {
      default: _withCtx(() => [
        (_ctx.openReviewEntry.isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_LoadingPanel)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.openReviewEntry.hasEntryInList.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ReviewEntryHeader),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openReviewEntry.entryList.value, (entry, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "w-full"
                      }, [
                        _createVNode(_component_ReviewEntryElement, {
                          entry: entry,
                          entryType: 'OPEN',
                          index: index,
                          length: _ctx.openReviewEntry.entryList.value.length
                        }, null, 8, ["entry", "index", "length"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('message.noData')), 1))
            ]))
      ]),
      _: 1
    }, 8, ["click", "title"]),
    _createVNode(_component_BasePanel, {
      class: "mt-5",
      icon: "speaker_notes_off",
      title: _ctx.$t(`message.closedEntries`)
    }, {
      default: _withCtx(() => [
        (_ctx.closeReviewEntry.isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_LoadingPanel)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.closeReviewEntry.hasEntryInList.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_ReviewEntryHeader),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closeReviewEntry.entryList.value, (entry, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "w-full"
                      }, [
                        _createVNode(_component_ReviewEntryElement, {
                          entry: entry,
                          entryType: 'CLOSE',
                          index: index,
                          length: _ctx.closeReviewEntry.entryList.value.length
                        }, null, 8, ["entry", "index", "length"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('message.noData')), 1))
            ]))
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}